var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.plotData.length)?_c('u-plot-stacked',{ref:"plot",attrs:{"data":_vm.plotData,"series":_vm.plotSeries,"dark":_vm.$vuetify.theme.dark,"duration":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }